import { render } from "./MontagesList.vue?vue&type=template&id=318f7386&scoped=true"
import script from "./MontagesList.vue?vue&type=script&lang=js"
export * from "./MontagesList.vue?vue&type=script&lang=js"

import "./MontagesList.vue?vue&type=style&index=0&id=318f7386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318f7386"]])

export default __exports__